import { render, staticRenderFns } from "./UpdateTicketDrawer.vue?vue&type=template&id=5230a516&scoped=true&"
import script from "./UpdateTicketDrawer.vue?vue&type=script&lang=js&"
export * from "./UpdateTicketDrawer.vue?vue&type=script&lang=js&"
import style0 from "./UpdateTicketDrawer.vue?vue&type=style&index=0&id=5230a516&prod&lang=sass&scoped=true&"
import style1 from "./UpdateTicketDrawer.vue?vue&type=style&index=1&id=5230a516&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5230a516",
  null
  
)

export default component.exports